import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-renewal-approval-form',
  templateUrl: './renewal-approval-form.component.html',
  styleUrls: ['./renewal-approval-form.component.css']
})
export class RenewalApprovalFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/recovery/renewal-approval/renewal-approval-form/renewal-approval-form.component.ts